/**
 * The standby peek on the playout screen (container; wave 7b-tail C): the
 * standby's own view of the show (`getStandbyPlayout`, re-read every 2 s)
 * beside the active state the screen already holds. Shown only beside the
 * ACTIVE's state of a production in a pair that has not ended (on the
 * standby's own node the screen shows the standby itself).
 */
import type { PlayoutState } from '@acp/api-contract/playout.js';
import { useStandbyPlayout } from '../app/hooks.js';
import { StandbyPeek } from '../components/redundancy/StandbyPeek.js';

export function StandbyPeekPanel({ productionId, state, ended }: { readonly productionId: string; readonly state: PlayoutState | null; readonly ended: boolean }) {
  if (state === null || state.redundancy?.role !== 'active' || ended) return null;
  return <Peek productionId={productionId} active={state} />;
}

function Peek({ productionId, active }: { readonly productionId: string; readonly active: PlayoutState }) {
  const standby = useStandbyPlayout(productionId);
  return <StandbyPeek active={active} standby={standby.data ?? null} error={standby.error === null ? null : standby.error instanceof Error ? standby.error.message : String(standby.error)} />;
}
